import React, { useEffect, useState } from "react";
import styles from "./user.scss";
import arrowRight from "./assets/icons/arrow-right.png";
import { useSelector } from "react-redux";
import { formatNumber, getQueryUTMString, getRouter } from "@tw/shared-ui-components/lib/utils/helper";
import { ac_enums, fetchAcState } from "../../redux/reducers/index";
import { useDispatch } from "react-redux";
import Cookies from "universal-cookie";
const User = (props) => {
  const { login, toggleCloseMenu } = props;
  const cookie = new Cookies();
  const curAda = cookie.get("ada");
  const ada = login.ada || "";
  const role = login.role || "";
  const users = login.user || [];
  const distributorType = login.distributorType;
  const isGuest = login.isGuest;
  const [couponNum, setCouponNum] = useState();
  const userState = useSelector((state) => state.userState.userInfo);
  const router = getRouter();
  const dispatch = useDispatch();
  useEffect(() => {
    // console.log("RETURNPROPS ", login);
    // if (userState === undefined) {
    //   () => count++;
    //   dispatch(fetchAcState(ac_enums.SET_USERINFO))
    // } else{
    //   console.log('TESTRYB' , userState, "TEST2" + distributorType + ada);
    // }
    dispatch(fetchAcState(ac_enums.SET_USERINFO));
  }, []);

  let curUser = {};
  if (users && users.length) {
    curUser = users[0];
  }
  if (role === "FOA" && curUser.name?.trim() === "") {
    curUser.name = "您好";
  }

  let link = { text: "", to: "", subText: "" };
  if (isGuest) {
    link = {
      text: "訪客",
      to: "",
      subText: "",
    };
  } else if (ada) {
    switch (role) {
      case "ABO":
        link = {
          text: "安麗直銷商",
          to: "",
          subText: "",
        };
        break;
      case "PM":
      case "SM":
        link = {
          text: "安麗會員",
          to: "",
          subText: "",
        };
        break;
      case "TC":
        link = {
          text: "安麗直銷商",
          to: "",
          subText: "（僅具有安麗產品訂購權利） ",
        };
        break;
      case "FOA":
        link = {
          text: "安麗之友",
          to: "",
          subText: "",
        };
        break;
    }
  }

  let isFOA = role === "FOA";
  /*<div className={styles.link}><Link to={link.to}>{link.text}</Link></div>*/
  const jumpDestinationAddress = (link) => {
    if (link.includes("/coupon")) {
      localStorage.setItem("opsTabType", JSON.stringify(["1"]))
    } else {
      localStorage.setItem("opsTabType", "0")
    }
    router.push(link);
  }
  return (
    <>
      {curAda && (
        <div className={styles.userContent}>
          <div className={styles.row}>
            <div className={styles.name}>{curUser.name}</div>
            <div
              className={`${styles.role} ${link.subText ? styles.role2line : ""
                }`}
            >
              {link.text}
              <span>{link.subText}</span>
            </div>
          </div>
          <div className={styles.row}>
            {!isFOA && (
              <>
                <a href={`javascript:void(0);`} onClick={() => jumpDestinationAddress(`/profile/points${getQueryUTMString('?')}`)}>
                  <div
                    className={`${styles.pointWrapper} ${styles.cols}`}
                    onClick={toggleCloseMenu}
                    style={{ marginRight: "4px" }}
                  >
                    <div className={styles.pTitle}>積點兌換</div>
                    <div className={styles.pValue}>
                      {userState && formatNumber(userState.points || 0)}
                      <span>
                        <img src={arrowRight} />
                      </span>
                    </div>
                  </div>
                </a>
                <a href={`javascript:void(0);`} onClick={() => jumpDestinationAddress(`/profile/coupon${getQueryUTMString('?')}`)}>
                  <div
                    className={`${styles.pointWrapper} ${styles.cols}`}
                    onClick={toggleCloseMenu}
                    style={{ marginLeft: "4px" }}
                  >
                    <div className={styles.pTitle}>電子券{userState && new Date(userState?.NewJoineeEndTime) > new Date && "+新人優惠"}</div>
                    <div className={styles.pValue}>
                      {userState && (
                        new Date(userState?.NewJoineeEndTime) > new Date
                          ? formatNumber((userState.coupons + userState.pointNewJoinee) || 0)
                          : formatNumber(userState.coupons || 0)
                      )}
                      <span>
                        <img src={arrowRight} />
                      </span>
                    </div>
                  </div>
                </a>
              </>
            )}

            {isFOA && (
              <>
                <a href={`javascript:void(0);`} onClick={() => jumpDestinationAddress(`/profile/coupon${getQueryUTMString('?')}`)}>
                  <div
                    className={`${styles.pointWrapper} ${styles.foa}`}
                    onClick={toggleCloseMenu}
                  >
                    <div className={styles.pTitle}>電子券{userState && new Date(userState?.NewJoineeEndTime) > new Date && "+新人優惠"}</div>
                    <div className={styles.pValue}>
                      {userState && (
                        new Date(userState?.NewJoineeEndTime) > new Date
                          ? formatNumber((userState.coupons + userState.pointNewJoinee) || 0)
                          : formatNumber(userState.coupons || 0)
                      )}
                      <span>
                        <img src={arrowRight} />
                      </span>
                    </div>
                  </div>
                </a>
              </>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default User;
